import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from "react";
import { DashboardQuery } from '../../../../types/files';
import ExportQuery from '../../dashboard-queries-export/ExportQuery';

const styles = StyleSheet.create({
    queryBlock: {
		width: '100%',
		height: 'auto',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
    },
    answerBlock: {
		width: '100%',
		height: 'auto',
		paddingTop: 8,
		paddingBottom: 8,
		color: '#666666',
    },
    title: {
		fontFamily: 'Poppins',
		fontSize: 12,
		fontWeight: 'bold',
		color: '#666666',
    },
});

const PDFFoundedQuery: React.FC<{ query?: DashboardQuery }> = ({ query }) => {
    return (<>
        <View style={styles.queryBlock}>
            <Text style={styles.title}>
                {'Year Founded'}
            </Text>
            <View style={styles.answerBlock}>
                <ExportQuery query={query} />
            </View>
        </View>
    </>);
}

export default PDFFoundedQuery;
